// @ts-nocheck

import type { TuneOptionsByPlatform } from '../../../common/types/appTypes';
import { ADS_PRESET_FIELDS } from '../../reducers/LinkCreatorReducer/utils';
export const TUNE_CLICK = 'click';
export const TUNE_IMPRESSION = 'impression';
// JOUR-3149: Mapping of Branch to Tune link macros for Ad Partner query params
const tuneParamsMapping = {
  '~ad_set_id': 'sub_adgroup',
  '~ad_set_name': 'sub_adgroup_name',
  '~agency': 'agency_name',
  '~campaign': 'sub_campaign_name',
  '~campaign_id': 'sub_campaign_id',
  '~click_id': 'publisher_ref_id',
  '~cost_model': 'cost_model',
  '~cost_value': 'cost',
  '~keyword': 'sub_keyword_name',
  '~keyword_id': 'sub_keyword',
  '~placement': 'sub_placement_name',
  '%24aaid': 'google_aid',
  '%24idfa': 'ios_ifa',
};

// We will arbitrarily choose a platform to use for the Tune value.
// Order of preference is 'ios', 'android', then any other.
const chooseTunePropertyForApp = (platforms: TuneOptionsByPlatform): any | null | undefined => {
  if (!platforms || !Object.keys(platforms).length) {
    return null;
  }

  // If ios or android aren't available, choose any other that are
  return platforms.ios || platforms.android || platforms[Object.keys(platforms)[0]];
};

export const getTuneDomain = (tuneSubdomainOptions: TuneOptionsByPlatform): string => {
  const tuneSubdomain = chooseTunePropertyForApp(tuneSubdomainOptions) || '';
  return `${tuneSubdomain}.tlnk.io`;
};
export const getDomain = (
  useTuneDomain: boolean,
  branchDomain: string,
  tuneSubdomainOptions: TuneOptionsByPlatform
): string => {
  const tuneDomain = getTuneDomain(tuneSubdomainOptions);
  return useTuneDomain ? tuneDomain : branchDomain;
};
export const getTuneBase = (siteIds: TuneOptionsByPlatform, action: string = TUNE_CLICK): string => {
  const tuneSiteId = chooseTunePropertyForApp(siteIds) || '';
  return 'serve?action=' + action + '&site_id=' + tuneSiteId;
};
// Convert key for query param to a Tune key, if it exists in mapping,
// otherwise retain the Branch key
export const buildTuneQueryObject = (queryObj: Record<string, any>): Record<string, any> =>
  Object.keys(queryObj || {}).reduce((converted, branchKey) => {
    const tuneKey = tuneParamsMapping[branchKey];
    const value = queryObj[branchKey];
    return { ...converted, [tuneKey || branchKey]: value };
  }, {});

// adding redirect key/value pairs to query string
const addRedirectsAsQueryParams = (data: Record<string, any>, queryStr: string): string => {
  const $android_deepview = data.$android_deepview || '';
  const $ios_deepview = data.$ios_deepview || '';
  const $desktop_deepview = data.$desktop_deepview || '';
  const $ios_url = data.$ios_url ? encodeURIComponent(data.$ios_url) : '';
  const $android_url = data.$android_url ? encodeURIComponent(data.$android_url) : '';
  const $desktop_url = data.$desktop_url ? encodeURIComponent(data.$desktop_url) : '';
  return (
    '' +
    ($ios_url && `url_ios=${$ios_url}&`) +
    ($android_url && `url_android=${$android_url}&`) +
    ($desktop_url && `url_web=${$desktop_url}&`) +
    ($ios_deepview && 'fbp_ios=1&') +
    ($android_deepview && 'fbp_android=1&') +
    ($desktop_deepview && 'fbp_web=1&') +
    queryStr
  );
};

// appending deeplinking key/value pairs to query string
const addCustomDataAsQueryParams = (data: Record<string, any>, queryStr: string): string => {
  let expandedQueryString = '';

  for (var property in data) {
    if (data.hasOwnProperty(property)) {
      if (ADS_PRESET_FIELDS.indexOf(property) === -1) {
        expandedQueryString = expandedQueryString + '&' + property + '=' + data[property];
      }
    }
  }

  return queryStr + expandedQueryString;
};

export const expandTuneQueryParams = (data: Record<string, any>, queryStr: string): string => {
  let tuneQueryStr = queryStr;
  tuneQueryStr = addRedirectsAsQueryParams(data, tuneQueryStr);
  tuneQueryStr = addCustomDataAsQueryParams(data, tuneQueryStr);
  return tuneQueryStr || '';
};
